import type { AIDefinitionsAction } from './actions';
import { AIDefinitionsActionType } from './actions';
import type { AIDefinitionsPluginState } from './types';

const reducer = (
	state: AIDefinitionsPluginState,
	action: AIDefinitionsAction,
): AIDefinitionsPluginState => {
	switch (action.type) {
		case AIDefinitionsActionType.UPDATE_KEYWORD_DECORATIONS:
			return {
				...state,
				keywordDecorations: action.keywordDecorations,
			};

		case AIDefinitionsActionType.TOGGLE_READING_AIDS_POPUP:
			return {
				...state,
				isReadingAidsPopupOpen: action.isReadingAidsPopupOpen,
				readingAidsPopupProps: action.readingAidsPopupProps,
			};

		default:
			return state;
	}
};

export default reducer;
